import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useAnalyticsPlanSync, useAuthBootstrap } from "./hooks/useAuth";
import { useCurrentUser } from "./hooks/useCurrentUser";
import { trackPageView } from "./lib/google-analytics";
import { useRobotsMeta } from "./hooks/useRobotsMeta";
import { DemoOpenOverlay } from "@/features/demo/DemoOpenOverlay";
import { AnnouncementWatcher } from "@/features/announcements/AnnouncementWatcher";

export function App() {
  useAuthBootstrap();
  useRobotsMeta();
  const { user, effectivePlan } = useCurrentUser();
  useAnalyticsPlanSync(user?.id ?? null, effectivePlan);
  const location = useLocation();

  useEffect(() => {
    const path = `${location.pathname}${location.search}`;
    trackPageView(path);
  }, [location.pathname, location.search]);

  useEffect(() => {
    const raf = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.dispatchEvent(new Event("prerender-ready"));
      });
    });
    return () => cancelAnimationFrame(raf);
  }, [location.pathname, location.search]);

  return (
    <>
      <DemoOpenOverlay />
      <AnnouncementWatcher />
      <Outlet />
    </>
  );
}
